module.exports = "../static/media/banner_short.0f7fae19.png";